import { apiClient, type ApiClient } from '../http'
import type { IChatbotApiResponse } from './types'
import type { DeploymentType } from '@/types/chatbot-types'

class ChatbotApi {
  static async getChatbot(
    chatbotId: string,
    client: ApiClient = apiClient
  ): Promise<IChatbotApiResponse> {
    return client.get(`/api/v1/chatbots/${chatbotId}`, { _t: Date.now() })
  }

  static async getChatbotByTenantId(
    tenantId: string,
    deploymentType?: DeploymentType,
    client: ApiClient = apiClient
  ): Promise<IChatbotApiResponse> {
    const params: Record<string, unknown> = { _t: Date.now() }
    if (deploymentType) {
      params.deploymentType = deploymentType
    }
    return client.get(`/api/v1/chatbots/tenant/${tenantId}`, params)
  }
}

export { ChatbotApi }
